
/**
 * Formats a modifier to conform with the current convention (m-modifier-name)
 * @param {any} modifierStr
 */
const _formatModifier = modifierStr =>
  /^m-/.test(modifierStr) ? modifierStr : `m-${modifierStr}`.toLowerCase()

/**
 * Toggles the presence of a modifier based on a given condition
 * @param {HTMLElement} $el
 * @param {Boolean} condition
 * @param {String} modifier
 */
const toggle = ($el, condition, modifier) => {
  if ($el == null || !modifier) return

  // Ensure the modifier string conforms with our pattern
  const mod = _formatModifier(modifier)

  condition
    ? $el.setAttribute(mod, '')
    : $el.removeAttribute(mod)
}

/**
 * Adds a css modifier to a given element
 * @param {HTMLElement} $el
 * @param {String} modifier
 */
const add = ($el, modifier) => {
  if ($el == null || !modifier) return

  $el.setAttribute(_formatModifier(modifier), '')
}

/**
 * Removes a css modifier from a given element
 * @param {HTMLElement} $el
 * @param {String} modifier
 */
const remove = ($el, modifier) => {
  if ($el == null || !modifier) return

  $el.removeAttribute(_formatModifier(modifier))
}

const CssModifiers = { toggle, add, remove }
export default CssModifiers



// WEBPACK FOOTER //
// ./js/utils/CssModifiers.js